import * as React from "react";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ReportActions from "report/reports-page/ReportActions";
import fetchReports from "report/reports-page/fetchReports";
import ReportQueryHelper from "report/reports-page/ReportQueryHelper";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import customColumnRenderers from "./ColumnRenderers";
import { getReportTableElements } from "../Constants";
const KEY_PREFIX = ["reports", "overview"];
const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
const ReportsList = () => {
  const { t } = useTranslation("enterprise_report");
  const entityActions = useCallback((listItem) => /* @__PURE__ */ React.createElement(ReportActions, { report: listItem }), []);
  const { pluggableColumnRenderers, pluggableAttributes, pluggableExpandedSections } = usePluggableEntityTableElements(null, "report");
  const { tableLayout, fetchOptions, additionalAttributes } = getReportTableElements(pluggableAttributes);
  const columnRenderers = useMemo(() => customColumnRenderers(pluggableColumnRenderers), [pluggableColumnRenderers]);
  const expandedSections = useMemo(
    () => ({
      ...pluggableExpandedSections
    }),
    [pluggableExpandedSections]
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: t("human_names.reports"),
      additionalAttributes,
      queryHelpComponent: /* @__PURE__ */ React.createElement(ReportQueryHelper, null),
      entityActions,
      entityAttributesAreCamelCase: false,
      tableLayout,
      fetchEntities: fetchReports,
      fetchOptions,
      keyFn,
      expandedSectionRenderers: expandedSections,
      columnRenderers
    }
  );
};
export default ReportsList;
